import { useParams } from 'react-router-dom';
import { TransactionChats } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemInternalTransaction from '../hooks/use-internal';

const InternalTransactionChats = () => {
  const {
    transaction,
    chats,
    senderCompanyOfficials,
    recipientCompanyOfficials,
  } = useAppSelector((state) => state.customersProblemTransactions.internal);
  const { currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList, activePermissions } = useAppSelector(
    (state) => state.root,
  );

  const { transactionId } = useParams();

  const { onCreateTransactionChat, chatCreateInProgress } =
    useProblemInternalTransaction({
      transactionId,
      transaction,
      currenciesList,
      currentEmployee,
    });

  return (
    <TransactionChats
      chats={chats}
      individualCustomer={transaction?.senderAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      recipients={recipientCompanyOfficials}
      senders={senderCompanyOfficials}
      recipientAccount={transaction?.recipientAccount}
      senderAccount={transaction?.senderAccount}
      activePermissions={activePermissions}
      internal
    />
  );
};

export default InternalTransactionChats;
